import React, {Fragment, useEffect, useState, useRef} from 'react';
import {productReservation, cart, subscribe, modal, global} from 'actions';
import {useDispatch, useSelector} from "react-redux";
import classNames from 'classnames';
import {parse} from "search-params";
import history from 'core/history';
import {t} from 'translates';
import PracticalInformation from './components/PracticalInfo';
import Session from './components/Session';
import Participants from './components/Participants';
import Languages from './components/Languages';
import Icon from 'common/components/Icon';
import { formatPriceWithDecimal } from 'common/helpers/priceFormat';

export const showMessage = (message, type, dispatch) => {
  dispatch(modal.show('reservation.error', {
    message,
    hideButton: false,
    type,
  }));

  const cursusModalTimeout = setTimeout(() => {
    dispatch(modal.hide('reservation.error'));
    clearTimeout(cursusModalTimeout);
  }, 8000);
};

export const addToCartGTM = (selectedSession, sessionsData, persons, productWrapperRef, analyticsValue) => {
  const selectedItem = sessionsData.sessions.filter(({id}) => (id === selectedSession));
  window.dataLayer && dataLayer.push({
    event: "add_to_cart",
    ecommerce: {
      currency: sessionsData.currency_code,
      items: [{
        item_name: sessionsData.original_title,
        item_id: sessionsData.product_id,
        price: selectedItem[0].full_price,
        item_category: sessionsData.original_category_name,
        item_type: sessionsData.original_category_type,
        quantity: 1,
        course_participants: persons,
        course_language: selectedItem[0].original_language,
        course_date: selectedItem[0].original_date,
        course_time: selectedItem[0].time,
        item_list_name: analyticsValue ? analyticsValue.item_list_name : 'N/A',
        item_list_id: analyticsValue ? analyticsValue.pg_type + ' - ' + analyticsValue.item_list_name + ' - ' + analyticsValue.url : 'N/A',
        index: analyticsValue ? analyticsValue.index : 0
      }]
    }
  });
  return false;
};

export const addToCart = (persons, selectedSession, dispatch, sessionsData, productWrapperRef, analyticsValue) => {
  const cursusToChange = storage.get(`cart.dialog.cursus`);
  let cursusSessions = [];
  for (const prop in cursusToChange) {
    cursusSessions = cursusSessions.concat(cursusToChange[prop].data.sessions);
  }

  if (cursusSessions.includes(selectedSession)) {
    showMessage(t("This session has already been added to your basket. Please select another session.", DT_CURSUS), 'error', dispatch);
    return false;
  }

  if (sessionsData.staffUser && selectedSession in storage.get(`cart.dialog.sessions`)) {
    showMessage(t('You cannot add twice the same session in your shopping bag', DT_RESERVATION), 'error', dispatch);
    return false;
  }
  dispatch(cart.addToCart(persons, selectedSession, 'sessions', {'analytics': analyticsValue}));
  dispatch(cart.showAddToCart(persons, selectedSession));

  addToCartGTM(selectedSession, sessionsData, persons, productWrapperRef, analyticsValue);
};

export const initAnalyticsValues = (id, setAnalyticsValue) => {
  let analytics = storage.get('analytics');
  let productData = null;
  if (analytics[id]) {
    productData = analytics[id];
    if (Date.now() - productData.timestamp < 60000) {
      setAnalyticsValue(productData);
    }

    delete analytics[id];
    storage.set('analytics', analytics);
  }

  return productData;
};

function ProductReservation() {

  const dispatch = useDispatch();
  const productWrapperRef = useRef();

  const {
    session_id
  } = parse(history.location.search);

  const productReservationData = useSelector(state => state.productReservation);
  const practicalInformaiton = useSelector(state => state.productReservation.practical_information);
  const sessionsData = useSelector(state => state.productReservation.sessions_data);
  const giftSertificate = useSelector(state => state.productReservation.gift_certificate);
  const modalState = useSelector(state => state.modal);
  const waitlistStatus = window.drupalSettings && window.drupalSettings.waitlistStatus;

  const [currentLanguage, setCurrentLanguage] = useState(0);
  const [filteredSessions, setFilteredSessions] = useState([]);
  const [selectedSessionFromUrl, setSelectedSessionFromUrl] = useState(session_id);
  const [selectedSession, setSelectedSession] = useState(undefined);
  const [selectedLoaction, setSelectedLocation] = useState(practicalInformaiton.location);
  const [redirectLink, setRedirectLink] = useState(undefined);
  const [maxPersons, setMaxPersons] = useState(1);
  const [price, setPrice] = useState(0);
  const [persons, setPersons] = useState(1);
  const [analyticsValue, setAnalyticsValue] = useState(null);

  useEffect(() => {
    setFilteredSessions(sessionsData.sessions);
  }, [sessionsData]);

  useEffect(() => {
    if (!selectedSession) return;
    const currentItem = filteredSessions.find(({id}) => id == selectedSession);

    setSelectedLocation(currentItem.location);
  }, [selectedSession]);

  useEffect(() => {
    if (filteredSessions && filteredSessions.length) {
      let currentItem = {};
      if (selectedSessionFromUrl) {
        setSelectedSessionFromUrl(undefined);
        currentItem = filteredSessions.find(({available_places, id}) => {
          return available_places > 0 && id == selectedSessionFromUrl
        })
        if (currentItem) {
          setSelectedSession(currentItem.id);
          setSelectedLocation(currentItem.location);
        } else {
          currentItem = filteredSessions.find(({available_places}) => {
            return available_places > 0
          })
        }
      } else {
        currentItem = filteredSessions.find(({available_places}) => {
          return available_places > 0
        })
      }

      if (currentItem) {
        setSelectedSession(currentItem.id);
        setSelectedLocation(currentItem.location);
      } else {
        setSelectedSession(undefined);
        setSelectedLocation(undefined);
      }
    } else {
      setSelectedSession(undefined);
      setSelectedLocation(undefined);
    }

    setPersons(1);

  }, [filteredSessions]);

  useEffect(() => {
    const $button = jQuery('.exhibition-list__btn');

    if (selectedSession !== undefined) {
      const currentItem = filteredSessions.find(({id}) => {
        return id == selectedSession
      })
      setMaxPersons(currentItem.session_bookable);
      setPrice(currentItem.full_price);
      if (sessionsData.is_3rd_party_subscription) {
        setRedirectLink(currentItem.redirect_link)
        $button.text(t('Register', DT_RESERVATION));
      }
      setPersons(1);
      $button.removeClass('hidden');
    } else {
      $button.addClass('hidden');
    }
  }, [selectedSession]);

  useEffect(() => {
    const {productId, itemListName} = productWrapperRef.current.parentNode.dataset;
    dispatch(productReservation.fetch(productId)).then((res) => {
      const {sessions_data: sessionsData} = res;
      let item_available = false;
      if (sessionsData && sessionsData.sessions && sessionsData.sessions.length > 0) {
        item_available = true;
      }

      const productData = initAnalyticsValues(sessionsData.product_id, setAnalyticsValue);
      window.dataLayer && dataLayer.push({
        event: "view_item",
        ecommerce: {
          currency: sessionsData.currency_code,
          items: [{
            item_id: sessionsData.product_id,
            item_name: sessionsData.original_title,
            price: sessionsData.product_price_amount,
            item_category: sessionsData.original_category_name,
            item_type: sessionsData.original_category_type,
            item_list_name: productData ? productData.item_list_name : 'N/A',
            item_list_id: productData ? productData.pg_type + ' - ' + productData.item_list_name + ' - ' + productData.url : 'N/A',
            item_available,
            index: productData ? productData.index : 0
          }]
        }
      });
    });
  }, []);

  const hideError = (e) => {
    e.preventDefault();
    dispatch(modal.hide('reservation.error'));
  }

  const changeLanguage = (id) => {
    setCurrentLanguage(id);
    setFilteredSessions(sessionsData.sessions.filter(({language}) => (language == id || id == 0)));
  }

  const handleClickWaitlist = (e) => {
    e.preventDefault();
    dispatch(subscribe.fetch(sessionsData.product_id, redirectLink));

    return false;
  }

  const handleClickGiftButton = () => {
    window.dataLayer && window.dataLayer.push({
      event: 'Offer_this_course',
      'name': sessionsData.original_title,
      'pgURI': window.location.pathname
    });

    return false;
  }

  const handleClickBookNow = () => {
    window.dataLayer && window.dataLayer.push({
      event: 'Register',
      'name': sessionsData.original_title,
      'pgURI': window.location.pathname
    });

    return false;
  }

  return (
    <div className='product-reservation-container' ref={productWrapperRef}>
      {(({isOpen, message, hideButton, type = 'type-error'}) => isOpen && (
        <div className={`message message--visible message--${type}`}>
          <span dangerouslySetInnerHTML={{__html: message}}/>
          <a
            href="#"
            onClick={hideError}
            style={{
              display: hideButton ? 'none' : 'inline-block',
            }}
            className="gift-modal-dialog__error-message-close"
          >
            <Icon name="close"/>
          </a>
        </div>
      ))(modalState['reservation.error'])}

      <PracticalInformation
        {...practicalInformaiton}
        location={selectedLoaction}
      />
      {sessionsData.sessions ? (
        sessionsData.sessions.length ? (
          <div className='product-reservation'>
            {!sessionsData.is_3rd_party_subscription ? (
              <h4>{t('Choose a session', DT_RESERVATION)}</h4>
            ) : (
              <h4>{t('Choose a time slot', DT_RESERVATION)}</h4>
            )}

            {productReservationData.languages.length && (
              <Fragment>
                <Languages
                  currentLanguage={currentLanguage}
                  languages={productReservationData.languages}
                  changeLanguage={changeLanguage}
                  productName={sessionsData.original_title}/>
              </Fragment>

            )}
            {filteredSessions && filteredSessions.length ? (
              <Fragment>
                <div className='product-reservation__items'>
                  {filteredSessions.map((item) => (
                    <Session
                      {...item}
                      color={sessionsData.color}
                      key={item.id}
                      selectedSession={selectedSession}
                      setSelectedSession={setSelectedSession}
                    />
                  ))}
                </div>
                {sessionsData.interpretation_text && (
                  <p className='product-reservation__interpretation-text'>*{sessionsData.interpretation_text}</p>
                )}
                {!sessionsData.is_3rd_party_subscription && (
                  <Participants
                    maxPersons={maxPersons}
                    persons={persons}
                    setPersons={setPersons}
                    staffUser={sessionsData.staffUser}
                  />
                )}
              </Fragment>
            ) : (
                !waitlistStatus ? (
                <p
                  className='product-reservation__no-sessions'>{t('All sessions have been taken. Please feel free to explore another course!', DT_RESERVATION)}</p>
              ) : (
                <p
                  className='product-reservation__no-sessions'>{t('New sessions available soon. Please subscribe to the wait list for updates', DT_RESERVATION)}</p>
              )
            )}
            <div className='product-reservation__price-block'>
              <p>
                {sessionsData.is_3rd_party_subscription ? (
                  <Fragment>
                    <span className='string-price string-price-free'>{t('Free', DT_RESERVATION)}. </span>
                    <span
                      className='string-price string-price-secondary'>{t('By Registration only', DT_RESERVATION)}.</span>
                  </Fragment>
                ) : price > 0 ? (
                    <span>{formatPriceWithDecimal(price * persons, sessionsData.currency_symbol, sessionsData.currency_separator, sessionsData.currency_decimal_separator, sessionsData.currency_position)}</span>
                ) : (
                  <span>{t('Free', DT_RESERVATION)}</span>
                )}
              </p>
              {!sessionsData.is_3rd_party_subscription ? (
                <button
                  className={classNames(`product-reservation__submit`, {
                    "product-reservation__submit--disabled": selectedSession == undefined,
                  })}
                  onClick={() => {
                    addToCart(persons, selectedSession, dispatch, sessionsData, productWrapperRef, analyticsValue)
                  }}>{t('Book', DT_RESERVATION)}
                </button>
              ) : (
                <a className='product-reservation__submit product-reservation__submit__register' target="_blank"
                   href={redirectLink} onClick={handleClickBookNow}>
                  {t('Register', DT_RESERVATION)}
                </a>
              )}
            </div>

          </div>) : (
          <Fragment>
              {!waitlistStatus ? (
              <p
                className='product-reservation__no-sessions'>{t('All sessions have been taken. Please feel free to explore another course!', DT_RESERVATION)}</p>
            ) : (
              <p
                className='product-reservation__no-sessions'>{t('New sessions available soon. Please subscribe to the wait list for updates', DT_RESERVATION)}</p>
            )}
            <div className='product-reservation__price-block'>
              <p>
                {sessionsData.is_3rd_party_subscription ? (
                  <Fragment>
                    <span className='string-price string-price-free'>{t('Free', DT_RESERVATION)}. </span>
                    <span
                      className='string-price string-price-secondary'>{t('By Registration only', DT_RESERVATION)}.</span>
                  </Fragment>
                ) : sessionsData.product_price_amount > 0 ? (
                  <span className='string-price'>{sessionsData.product_price}</span>
                ) : (
                  <span>{t('Free', DT_RESERVATION)}</span>
                )}
              </p>
                {waitlistStatus && (
                <button className='product-reservation__submit'
                        onClick={(e) => {
                          handleClickWaitlist(e)
                        }}>
                  {t('Subscribe to wait list', DT_SESSIONS)}
                </button>
              )}
            </div>
          </Fragment>
        )
      ) : null
      }


      {giftSertificate.url && (
        <Fragment>
          <div className='product-gift-certificate'>
            <div className='product-gift-certificate__data'>
              <p>{giftSertificate.title}</p>
              <p>{giftSertificate.text}</p>
            </div>
            <a className='product-gift-certificate__button' href={giftSertificate.url} onClick={handleClickGiftButton}>
              {giftSertificate.button_label}
            </a>
          </div>
        </Fragment>
      )}

    </div>
  );
}

export default ProductReservation;
